// action types
const ADD_ADDON_CATEGORIES = 'app-name/addOnCategories/ADD_ADDON_CATEGORIES'

// reducer
export default (state = {}, { payload, type }) => {
  switch (type) {
    case ADD_ADDON_CATEGORIES:
      return { ...state, ...payload }
    default:
      return state
  }
}

// action creators
export const addOnCategories = payload => ({
  type: ADD_ADDON_CATEGORIES,
  payload,
})
